import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

function ContentRow(props) {
  const { classes, children, customClass } = props;

  return (
    <div className={`${classes.root} ${customClass}`}>
      {children}
    </div>
  );
}

ContentRow.propTypes = {
  classes: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
  customClass: PropTypes.string,
};

ContentRow.defaultProps = {
  customClass: '',
};

export default withStyles(styles)(ContentRow);
